"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLifecycleStates = void 0;
exports.getQueryParam = getQueryParam;
exports.hasToShowDisallowedPromotionModal = exports.getStatusLabel = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _querystring = require("querystring");
var _types = require("./types");
var getStatusLabel = exports.getStatusLabel = function getStatusLabel(status) {
  var _statusMap$status;
  var statusMap = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _types.AssetStatus.PUBLISHED, 'Stable'), _types.AssetStatus.DEPRECATED, 'Deprecated'), _types.AssetStatus.DEVELOPMENT, 'Development');
  return (_statusMap$status = statusMap[status]) !== null && _statusMap$status !== void 0 ? _statusMap$status : status;
};
var hasToShowDisallowedPromotionModal = exports.hasToShowDisallowedPromotionModal = function hasToShowDisallowedPromotionModal(status) {
  var lifecycleStateActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    statusTransitions: []
  };
  var statusTransitions = lifecycleStateActions.statusTransitions;
  var _ref = statusTransitions.find(function (_ref2) {
      var targetStatus = _ref2.targetStatus;
      return targetStatus === _types.AssetStatus.PUBLISHED;
    }) || {},
    _ref$affordance = _ref.affordance,
    affordance = _ref$affordance === void 0 ? 'allowed' : _ref$affordance,
    _ref$affordanceDetail = _ref.affordanceDetails,
    affordanceDetails = _ref$affordanceDetail === void 0 ? [] : _ref$affordanceDetail;
  var hasDevelopmentDependencies = affordanceDetails.some(function (_ref3) {
    var code = _ref3.code;
    return code === _types.DEVELOPMENT_DEPENDENCIES;
  });
  return status === _types.AssetStatus.DEVELOPMENT && affordance === 'disallowed' && hasDevelopmentDependencies;
};

/**
 * "statusTransitions": [
        {
            "targetStatus": "development",
            "affordance": "allowed",
        },
        {
            "targetStatus": "published",
            "affordance": "allowed",
        },
        {
            "targetStatus": "deprecated",
            "affordance": "disallowed",
        },
        {
            "targetStatus": "deleted",
            "affordance": "allowed",
        },
        {
            "targetStatus": "hard-deleted",
            "affordance": "allowed",
        }
    ]
 *  1. filter if targetStatus is deleted
 *  2. filter the currently status
 *  3. filter all the "disallowed" status
 *  4. filter by permisions
 *  4. I get the "allowed" statuses as a string array
  */
var getEnabledStates = function getEnabledStates(status, canEdit, canAdmin, _ref4) {
  var statusTransitions = _ref4.statusTransitions;
  return statusTransitions.filter(function (_ref5) {
    var targetStatus = _ref5.targetStatus;
    return !_types.ASSET_DELETED_STATUS.includes(targetStatus);
  }).filter(function (_ref6) {
    var affordance = _ref6.affordance,
      targetStatus = _ref6.targetStatus;
    return status !== targetStatus && affordance !== 'disallowed';
  }).filter(function () {
    return canAdmin || canEdit && status === _types.AssetStatus.DEVELOPMENT;
  }).map(function (statusTransition) {
    return statusTransition.targetStatus;
  });
};
var getLifecycleStates = exports.getLifecycleStates = function getLifecycleStates(status, canEdit, canAdmin) {
  var lifecycleStateActions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    statusTransitions: []
  };
  var enabledStates = getEnabledStates(status, canEdit, canAdmin, lifecycleStateActions);
  var showDisallowedPromoting = hasToShowDisallowedPromotionModal(status, lifecycleStateActions);
  return [{
    label: getStatusLabel(_types.AssetStatus.DEVELOPMENT),
    disabled: !enabledStates.includes(_types.AssetStatus.DEVELOPMENT),
    targetState: _types.AssetStatus.DEVELOPMENT,
    showDisallowedPromoting: false
  }, {
    label: getStatusLabel(_types.AssetStatus.PUBLISHED),
    disabled: !enabledStates.includes(_types.AssetStatus.PUBLISHED) && !showDisallowedPromoting,
    targetState: _types.AssetStatus.PUBLISHED,
    showDisallowedPromoting: showDisallowedPromoting
  }].concat((0, _toConsumableArray2.default)(canAdmin ? [{
    label: getStatusLabel(_types.AssetStatus.DEPRECATED),
    disabled: !enabledStates.includes(_types.AssetStatus.DEPRECATED),
    targetState: _types.AssetStatus.DEPRECATED,
    showDisallowedPromoting: false
  }] : []));
};
function getQueryParam(location, param) {
  var _location$search;
  var queryStr = location === null || location === void 0 || (_location$search = location.search) === null || _location$search === void 0 ? void 0 : _location$search.replace('?', '');
  if (!queryStr) {
    return [];
  }
  var query = (0, _querystring.parse)(queryStr);
  if (!query[param]) {
    return [];
  }
  if (Array.isArray(query[param])) {
    return query[param];
  }
  return [query[param]];
}
//# sourceMappingURL=utils.js.map